import { render } from 'preact'
import { lazy, Suspense } from 'preact/compat'
import Router from 'preact-router'
import 'preact-cli/lib/lib/webpack/polyfills'
import 'src/utils/sentry'
import 'src/script/third-party/google-analytics'

const HotpayCheckout = lazy(() => import('./App'))
const CardExchange = lazy(() => import('./tools/card-exchange/CardExchange'))
const Auth = lazy(() => import('./Auth'))
const CheckoutLoader = lazy(() => import('./CheckoutLoader'))
const SparkleRedirect = lazy(() => import('./SparkleRedirect'))

const Routes = () => (
  <Suspense fallback={<div />}>
    <Router>
      <HotpayCheckout path="/checkout/:linkRef" />
      <CardExchange path="/card-exchange/" />
      <Auth path="/auth/:authRoute" />
      <SparkleRedirect path="/_redirect" />
      <CheckoutLoader path="/:linkRef" />
    </Router>
  </Suspense>
)

render(<Routes />, document.querySelector('.HotpayPaaS'))



// WEBPACK FOOTER //
// ./Routes.js